import { fork, take, call, put } from "redux-saga/effects";
import types from "./types";
import { apiDirect, postAPIWithoutModule } from "../../api/generic";
import { getGlobalSearchCourseResponse, getGlobalSearchLPResponse, getLPsWithSubscriptionResponse, getMyOBLPListingResp, getNONOBLPListingResp, getNonMyOBLPListingResp, getOBLPListingResp } from "./actions";

export function* doGetOBLPListing() {
    while (true) {
        const { payload } = yield take(types.GET_OBLP_LISTING)
        const response = yield call(apiDirect, payload)
        yield put(getOBLPListingResp(response))
    }
}

export function* doGetNonOBLPListing() {
    while (true) {
        console.log('GET NON OBLP LIST')
        const { payload } = yield take(types.GET_NON_OBLP_LISTING)
        console.log(payload)
        const response = yield call(apiDirect, payload)
        yield put(getNONOBLPListingResp(response))
    }
}

export function* doGetMyOBLPListing() {
    while (true) {
        const { payload } = yield take(types.GET_MY_OBLP_LISTING)
        const response = yield call(apiDirect, payload)
        yield put(getMyOBLPListingResp(response))
    }
}

export function* doGetMyNonOBLPListing() {
    while (true) {
        const { payload } = yield take(types.GET_NON_MY_OBLP_LISTING)
        const response = yield call(apiDirect, payload)
        yield put(getNonMyOBLPListingResp(response))
    }
}

export function* doGetGlobalSearchLP() {
    while (true) {
        const { payload } = yield take(types.GLOBAL_SEARCH_LP)
        const response = yield call(postAPIWithoutModule, payload)
        yield put(getGlobalSearchLPResponse(response))
    }
}
export function* doGetGlobalSearchCourse() {
    while (true) {
        const { payload } = yield take(types.GLOBAL_SEARCH_COURSE)
        const response = yield call(postAPIWithoutModule, payload)
        yield put(getGlobalSearchCourseResponse(response))
    }
}

export function* doGetLpIncludedWithSubscription() {
    while (true) {
        const { payload } = yield take(types.LP_INCLUDED_WITH_SUBSCRIPTION)
        const response = yield call(postAPIWithoutModule, payload)
        yield put(getLPsWithSubscriptionResponse(response))
    }
}

function* getRes() {
    yield fork(doGetOBLPListing)
    yield fork(doGetNonOBLPListing)
    yield fork(doGetMyOBLPListing)
    yield fork(doGetMyNonOBLPListing)
    yield fork(doGetGlobalSearchLP)
    yield fork(doGetGlobalSearchCourse)
    yield fork(doGetLpIncludedWithSubscription)
}

export default getRes;